<template>
  <span>
    <v-btn
      v-if="iMostSing"
      outlined
      small
      color="blue darken-3"
      :disabled="itsSigned"
      @click="firmarDocumento"
    >
      Firmar
    </v-btn>
  </span>
</template>

<script>
import { userData } from '@/store/helpers'
import { signingWizardActions } from '@/modules/signers/store/signingWizardStoreHelpers'
import { fielStorageActions } from '@/modules/signers/store/fielStorageHelpers'

export default {
  name: 'DocumentSign',
  props: {
    value: {
      type: Array
    },
    idDocumento: {
      type: String
    },
    status: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...userData,
    itsSigned(){
      return this.signer && 
        (this.signer.firmado || this.status.descripcion == 'Expirado')
    },
    signer(){
      return this.value.find(s => s.esUsuario)
    },
    iMostSing() {
      return this.status.descripcion != 'Cancelado' 
        && this.signer 
        && this.signer.activo
        && this.signer.email == this.accountData.email
    }
  },
  methods: {
    ...signingWizardActions,
    ...fielStorageActions,
    firmarDocumento() {
      this.setDocumentWizard(this.idDocumento)
      this.setSignerWizard(this.signer.idFirmante)
      this.setFielRfcToCompare(this.accountData.rfc)
      this.openWizard()
    }
  }
}
</script>
